// @flow

import _ from 'lodash';
import Q from 'q';

import type { SplunkLoggerInterface } from './types';

export const noopLogger: SplunkLoggerInterface = {
	push: _.noop,
	flush: _.constant(Q()),
	withAuthContext () {
		return this;
	},
	withLogContext () {
		return this;
	},
};
